import { render, staticRenderFns } from "./QuotationProjectHeader.vue?vue&type=template&id=761b02ab"
import script from "./QuotationProjectHeader.vue?vue&type=script&lang=js"
export * from "./QuotationProjectHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports